export function isKeyable(value: any) {
    let type = typeof (value);
    switch (type) {
        case 'string':
        case 'number':
            return true
        default:
            return false
    }
}

export default isKeyable
